import { render, staticRenderFns } from "./AddressInfo.vue?vue&type=template&id=237ed8a6&scoped=true"
import script from "./AddressInfo.vue?vue&type=script&lang=js"
export * from "./AddressInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237ed8a6",
  null
  
)

export default component.exports